module.exports = __webpack_public_path__ + "static/media/julien-sarazin-n3mK4n_nF7g-unsplash_mobile.260a4b0e.jpg";